import { render, staticRenderFns } from "./admin-details.vue?vue&type=template&id=279885a8"
import script from "./admin-details.vue?vue&type=script&lang=ts"
export * from "./admin-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports